import {
  IEntityCriteriaSimpleOperator,
  IEntityCriteriaCompoundOperator,
  ITieredEntitySelectionCriterion,
} from '../../../../common/types/shared/entitySelection';

export const isValidCriterionComparisonValue = (
  _criterion: ITieredEntitySelectionCriterion,
) => {
  // TODO: implement this properly
  return true;
};

export const isValidCriterion = (
  criterion: ITieredEntitySelectionCriterion,
) => {
  return (
    criterion &&
    criterion.selectionPath &&
    criterion.comparator &&
    isValidCriterionComparisonValue(criterion)
  );
};

export const isValidOperator = (operator: IEntityCriteriaSimpleOperator) => {
  return (
    !!operator.operator && !operator.criteria.some((c) => !isValidCriterion(c))
  );
};

export const isValidCompoundOperator = (
  operator: IEntityCriteriaCompoundOperator,
): boolean => {
  return (
    !!operator.operator &&
    !operator.criteria.criteria.some((c) => !isValidCriterion(c)) &&
    !(operator.criteria.simpleOperators ?? []).some(
      (simpleOperator) => !isValidOperator(simpleOperator),
    ) &&
    !(operator.criteria.compoundOperators ?? []).some(
      (compoundOperator) => !isValidCompoundOperator(compoundOperator),
    )
  );
};
